import type { FrameProvider } from "../../infrastructure/codecs/WebCodecsVideoEncoder";
import { encodeVideoFrames } from "../../infrastructure/codecs/WebCodecsVideoEncoder";
import type {
  VideoEncodingProgress,
  VideoEncodingSettings,
  VideoMuxer,
} from "./videoEncoding";

export type ExportVideoOptions = {
  settings: VideoEncodingSettings;
  frameProvider: FrameProvider;
  muxer: VideoMuxer;
  signal?: AbortSignal;
  onProgress?: (progress: VideoEncodingProgress) => void;
};

export async function exportVideo({
  settings,
  frameProvider,
  muxer,
  signal,
  onProgress,
}: ExportVideoOptions) {
  const encoded = await encodeVideoFrames({
    settings,
    frameProvider,
    signal,
    onProgress,
  });

  if (signal?.aborted) {
    throw signal.reason ?? new DOMException("Video export cancelled.", "AbortError");
  }

  return muxer.mux(encoded);
}
